/* eslint-disable */
import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./lura-landing.css";
import markup from "./landingMarkup";
import { bootLanding } from "./landingBoot";
import { WhatsAppButton } from "../components/WhatsAppButton";
import { useI18n } from "../i18n";
import { useTheme } from "../context/ThemeContext";

const LANGS = ["es", "en", "fr", "pt", "it"];

// SEO por idioma: reutiliza copy aprobada (eyebrow + sub). Sin afirmaciones nuevas, sin precios.
const SEO = {
  es: { title: "Lura Finance — Gestión financiera personal y profesional", desc: "Importa tus extractos, fotografía tus tickets y guarda tus contratos. Lura te dice qué entra, qué sale y cuánto queda.", ogl: "es_ES" },
  en: { title: "Lura Finance — Personal and business money management", desc: "Import your statements, snap your receipts and keep your contracts. Lura shows what comes in, what goes out and what is left.", ogl: "en_US" },
  fr: { title: "Lura Finance — Gestion financière personnelle et professionnelle", desc: "Importez vos relevés, photographiez vos tickets et gardez vos contrats. Lura vous montre ce qui entre, ce qui sort et ce qu’il reste.", ogl: "fr_FR" },
  pt: { title: "Lura Finance — Gestão financeira pessoal e profissional", desc: "Importe seus extratos, fotografe seus recibos e guarde seus contratos. A Lura mostra o que entra, o que sai e quanto sobra.", ogl: "pt_PT" },
  it: { title: "Lura Finance — Gestione finanziaria personale e professionale", desc: "Importa i tuoi estratti conto, fotografa gli scontrini e conserva i contratti. Lura ti mostra cosa entra, cosa esce e quanto resta.", ogl: "it_IT" },
};

function setAttr(sel, attr, val) {
  const el = document.querySelector(sel);
  if (el) el.setAttribute(attr, val);
}

function applySEO(loc) {
  const s = SEO[loc] || SEO.es;
  const origin = window.location.origin;
  document.title = s.title;
  setAttr('meta[name="description"]', "content", s.desc);
  setAttr("#og-title", "content", s.title);
  setAttr("#tw-title", "content", s.title);
  setAttr("#og-desc", "content", s.desc);
  setAttr("#tw-desc", "content", s.desc);
  setAttr("#og-locale", "content", s.ogl);
  setAttr("#og-url", "content", origin + "/");
  setAttr("#og-image", "content", origin + "/lura-word-light.png");
  setAttr("#seo-canonical", "href", origin + "/");
  setAttr("#hreflang-x", "href", origin + "/");
  LANGS.forEach((l) => setAttr("#hreflang-" + l, "href", origin + "/?lang=" + l));
}

export default function Landing() {
  const ref = useRef(null);
  const navigate = useNavigate();
  const { locale, setLocale } = useI18n();
  const { setTheme } = useTheme();

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    // Idioma inicial: ?lang= -> chave da app -> navegador -> ES. Mesma chave que /login y /register.
    const urlLang = new URLSearchParams(window.location.search).get("lang");
    let loc = LANGS.includes(urlLang) ? urlLang : localStorage.getItem("lura_locale");
    if (!LANGS.includes(loc)) {
      const nav = (navigator.language || "es").slice(0, 2).toLowerCase();
      loc = LANGS.includes(nav) ? nav : "es";
    }
    // El mockup lee 'lura-lang' en su init: lo sembramos con el idioma de la app.
    try { localStorage.setItem("lura-lang", loc); } catch (e) {}
    if (locale !== loc) setLocale(loc);
    document.documentElement.lang = loc;
    applySEO(loc);

    el.innerHTML = markup;
    try { bootLanding(); } catch (e) { console.warn("landing boot failed:", e); }

    const sel = el.querySelector("#lang");
    // Espelha a mudança de idioma do mockup para o contexto da app (persiste + html lang + SEO + /login /register).
    const syncFromSelect = () => {
      const v = sel && sel.value;
      if (LANGS.includes(v)) { setLocale(v); document.documentElement.lang = v; applySEO(v); }
    };
    if (sel) sel.addEventListener("change", syncFromSelect);

    const onClick = (ev) => {
      const target = ev.target;
      // Chips de la sección "Idiomas": enruta por el <select> (fuente única del mockup).
      const chip = target.closest && target.closest(".lchip");
      if (chip && el.contains(chip)) {
        const v = chip.getAttribute("data-l");
        if (sel && LANGS.includes(v)) {
          sel.value = v;
          sel.dispatchEvent(new Event("change", { bubbles: true }));
        }
        return;
      }
      // Botão de tema do mockup: deixa o boot alternar data-theme e sincroniza o ThemeContext da app (ícone + estado coerentes).
      const themeBtn = target.closest && target.closest("#theme");
      if (themeBtn && el.contains(themeBtn)) {
        setTimeout(() => {
          const t = document.documentElement.getAttribute("data-theme") || "light";
          setTheme(t);
        }, 0);
        return;
      }
      const a = target.closest && target.closest("a,button");
      if (!a || !el.contains(a)) return;
      const key = a.getAttribute("data-i18n") || "";
      const go = (to) => { ev.preventDefault(); navigate(to); };
      if (key === "login") return go("/login");
      if (key === "signup" || key === "cta1" || key === "pc_cta" || key === "ft_aff") return go("/register");
      if (key === "ft_priv" || key === "se_link") return go("/privacidad");
    };
    el.addEventListener("click", onClick);

    return () => {
      if (sel) sel.removeEventListener("change", syncFromSelect);
      el.removeEventListener("click", onClick);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="lura-v5" ref={ref} data-testid="landing-root" />
      <WhatsAppButton />
    </>
  );
}
